export { default as TalentProfileMatchScore } from './TalentProfileMatchScore';
export { default as TalentProfileHireConfidence } from './TalentProfileHireConfidence';
export { default as TalentProfileResumeScore } from './TalentProfileResumeScore';
export { default as TalentProfilePortfolio } from './TalentProfilePortfolio';
export { default as TalentProfileEducation } from './TalentProfileEducation';
export { default as TalentProfileWorkHistory } from './TalentProfileWorkHistory';
export { default as TalentProfileProjectInterests } from './TalentProfileProjectInterests';
export { default as TalentProfileAbout } from './TalentProfileAbout';
export { default as TalentProfileRolesSkills } from './TalentProfileRolesSkills';
export { default as TalentProfileDetails } from './TalentProfileDetails';
export { default as TalentProfileIndustryExperience } from './TalentProfileIndustryExperience';
export { default as TalentProfileBrandExperience } from './TalentProfileBrandExperience';
export { default as TalentProfileWorkHighlights } from './TalentProfileWorkHighlights';
export { default as TalentProfileSkills } from './TalentProfileSkills';
export { default as TalentProfileReferences } from './TalentProfileReferences';
export { default as TalentProfileCertifications } from './TalentProfileCertifications';
export { default as TalentProfileAwards } from './TalentProfileAwards';
export { default as TalentProfileWrippleProjects } from './TalentProfileWrippleProjects';
export { default as TalentProfileInterviews } from './TalentProfileInterviews';
export { default as TalentProfileWorkPreferences } from './TalentProfileWorkPreferences';
export { default as TalentProfileTeams } from './TalentProfileTeams';
export { default as AgencyProfileDetails } from './AgencyProfileDetails';
export { default as TalentProfileMembers } from './TalentProfileMembers';
export { default as TalentProfileAiExperience } from './TalentProfileAiExperience';
export { default as TalentProfileRoles } from './TalentProfileRoles';
export { default as AgencyProfileServicesOffered } from './AgencyProfileServicesOffered';
export { default as AgencyProfilePartnerPrograms } from './AgencyProfilePartnerPrograms';
export { default as AgencyProfileWorkGallery } from './AgencyProfileWorkGallery';
export { default as AgencyProfileLocations } from './AgencyProfileLocations';
export { default as AgencyProfileTeams } from './AgencyProfileTeams';
export { default as AgencyProfileAboutUs } from './AgencyProfileAboutUs';
